export default "__VITE_ASSET__D17L9BWa__"